// extracted by mini-css-extract-plugin
module.exports = {"userData":"styles_userData__1liUs","popover":"styles_popover__3JXlU"};